<template>
  <div>
    <v-alert
      v-if="!loading && reviewsPackage.type == 'trial'"
      type="info"
      icon="timelapse"
      class="py-0 mb-4"
      mb-4
      prominent
      text
      dense
    >
      <v-row align="center">
        <v-col class="grow"
          ><strong>Proefperiode</strong> van Reviews is actief voor
          {{ activeCompData.name }}.
        </v-col>
        <v-col class="shrink">
          <v-btn color="info" outlined>
            Nog {{ reviewsPackage.days }}
            <span style="color: #2196f3" v-if="reviewsPackage.days == 1"
              >dag</span
            ><span style="color: #2196f3" v-else>dagen</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <div v-if="!loading && companies.length > 1" class="pt-2">
      <v-container grid-list-md class="pa-0" fluid>
        <v-layout row wrap>
          <v-flex md3 xs12>
            <v-select
              v-if="!loading && companies.length > 1 && !demoMode"
              :items="filteredCompanies"
              :item-color="companyPrimaryColor"
              :background-color="$vuetify.theme.themes[theme].menu"
              item-text="name"
              item-value="id"
              hide-details
              v-on:input="loadCompanyJourneys()"
              v-model="filter.selectedCompany"
              no-data-text="Geen bedrijven gevonden."
              label="Selecteer bedrijf"
              outlined
              dense
            >
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content class="pt-0">
                    <v-text-field
                      :color="companyPrimaryColor"
                      placeholder="Zoeken"
                      append-icon="search"
                      v-model="searchCompanies"
                      hide-details
                      dense
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <div
                  v-if="searchCompanies && searchCompanies.length > 0"
                  style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px"
                >
                  {{ filteredCompanies.length }} van
                  {{ companies.length }} bedrijven
                </div>
                <v-divider
                  v-if="searchCompanies && searchCompanies.length > 0"
                ></v-divider>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <div v-if="loading || loadingUserData" class="blackbox-loader"></div>

    <v-card outlined v-if="!loadingUserData" class="mt-4">
      <v-container grid-list-md fluid class="ma-0 pa-1">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex md6>
            <v-select
              class="px-1"
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="branches"
              item-text="branchName"
              item-value="id"
              v-model="filter.selectedBranches"
              label="Vestigingen"
              small-chips
              multiple
              hide-details
            ></v-select>
          </v-flex>
          <v-flex md6>
            <v-select
              class="px-1"
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="journeys"
              item-text="name"
              item-value="id"
              v-model="filter.selectedJourney"
              label="Journey"
              hide-details
            ></v-select>
          </v-flex>
          <v-flex md3>
            <v-menu
              ref="dateDialog"
              :close-on-content-click="false"
              v-model="filter.startDateDialog"
              transition="scale-transition"
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  :color="companyPrimaryColor"
                  slot="activator"
                  prepend-icon="event"
                  v-model="filterStartDateFormatted"
                  label="Start"
                  hide-details
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                :color="companyPrimaryColor"
                v-model="filter.startDate"
                :min="minDate"
                :max="today"
                :show-current="true"
                no-title
                @input="filter.startDateDialog = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex md3>
            <v-menu
              ref="dateDialog"
              :disabled="!filter.startDate"
              :close-on-content-click="false"
              v-model="filter.endDateDialog"
              transition="scale-transition"
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  :color="companyPrimaryColor"
                  prepend-icon="event"
                  v-model="filterEndDateFormatted"
                  label="Eind"
                  hide-details
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                :color="companyPrimaryColor"
                v-model="filter.endDate"
                :min="filter.startDate"
                :max="today"
                :show-current="true"
                no-title
                @input="filter.endDateDialog = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md3>
            <v-switch
              class="pa-1"
              v-model="filter.answered"
              label="Survey beantwoord"
              :color="companyPrimaryColor"
              hide-details
            ></v-switch>
          </v-flex>

          <v-flex md3>
            <v-btn
              block
              large
              :depressed="filterChanged"
              :disabled="filterChanged"
              :color="companyPrimaryColor"
              @click="loadSurveys()"
            >
              <span style="color: #fff;">Filteren</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <div class="no-salon-data" v-if="!loading && noData">
      <p>
        Selecteer salons en klik op <strong>Filteren</strong> om data te laden.
      </p>
    </div>

    <v-card v-if="!loading && clients.length > 0" outlined class="mt-4">
      <v-card-title>
        <v-text-field
          style="max-width: 300px;"
          v-model="search"
          :color="companyPrimaryColor"
          placeholder="Zoeken"
          outlined
          hide-details
          background-color="background"
          prepend-inner-icon="search"
          autocomplete="disabled"
          clearable
        >
        </v-text-field>
        <v-spacer></v-spacer>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="clients"
        :search="search"
        :items-per-page="50"
        :no-results-text="`Geen resultaten gevonden voor: ${search}`"
      >
        <template v-slot:item="{ item }">
          <tr @click="viewClient(item)">
            <td>
              {{ item.clientName }}
              <span v-show="item.clientMiddleName">{{
                item.clientMiddleName
              }}</span>
              {{ item.clientLastName }}
            </td>
            <td>
              <span v-for="gender in genders" :key="gender.id">
                <span v-if="item.clientGender == gender.id">{{
                  gender.name
                }}</span>
              </span>
            </td>
            <td>{{ item.lastDateSend.seconds | moment("D MMMM YYYY") }}</td>
            <td style="text-align: center;">{{ item.clientSurveysNumber }}</td>

            <td>
              <span v-if="item.clientTotalScore">
                <span
                  class="client-data-smiley block"
                  v-bind:class="'score-' + Math.round(item.clientTotalScore)"
                ></span>
                <span class="client-data-score">{{
                  (item.clientTotalScore * 2).toFixed(1)
                }}</span>
              </span>
            </td>
            <td>
              <span v-if="item.clientQuestionsAnswered">{{
                item.clientQuestionsAnswered
              }}</span>
            </td>
            <td>
              <span v-if="item.clientLowestScore" class="client-data-score">
                <span
                  class="client-data-smiley block"
                  v-bind:class="'score-' + Math.round(item.clientLowestScore)"
                ></span>
                <span class="client-data-score">{{
                  (item.clientLowestScore * 2).toFixed(1)
                }}</span>
                <v-icon v-if="item.clientLowestScore < 4" small color="warning"
                  >warning</v-icon
                >
              </span>
            </td>
            <td style="text-align: center;">
              <span v-if="item.clientFeedback">Ja</span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <!-- / View Client Dialog \ -->
    <v-dialog v-model="viewClientDialog" max-width="750px" scrollable>
      <client-data-modal
        :activeCompData="activeCompData"
        :clientDataLoaded="clientDataLoaded"
        :clientSurveys="clientSurveys"
        :branches="branches"
        :viewClientInfo="viewClientInfo"
        @closeClientViewDialogChange="closeClientViewDialog()"
      ></client-data-modal>
    </v-dialog>
    <!-- \ View Client Dialog / -->
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import db from "../firebase/init";
import moment from "moment";
import _ from "lodash";
import ClientDataModal from "../components/modals/ClientDataModal.vue";
import { bus } from "../main";

export default {
  components: {
    "client-data-modal": ClientDataModal,
  },
  name: "clients",
  data: () => ({
    search: "",
    loading: true,
    clientPages: -1,
    loadingUserData: true,
    userDataLoaded: false,
    clientDataLoaded: false,
    dataloaded: false,
    noData: true,
    activeCompData: null,
    activeCompDataOriginal: null,

    filter: {
      selectedCompany: null,
      selectedBranches: [],
      selectedJourney: [],
      startDate: null,
      startDateDialog: false,
      endDate: null,
      endDateDialog: false,
      answered: true,
    },

    filterSaved: {
      selectedCompany: null,
      selectedBranches: [],
      selectedJourney: [],
      startDate: null,
      startDateDialog: false,
      endDate: null,
      endDateDialog: false,
      answered: true,
    },

    minDate: null,
    today: null,

    journeys: [],
    branches: [],
    companies: [],
    surveys: [],
    surveyClients: [],

    // activeComp: [],

    genders: [
      {
        id: "male",
        name: "Man",
      },
      {
        id: "female",
        name: "Vrouw",
      },
    ],
    viewClientDialog: false,
    clients: [],
    viewClientInfo: {},
    clientSurveys: {},
    searchCompanies: "",
    headers: [
      {
        text: "Naam",
        align: "left",
        value: "clientName",
        sortable: true,
      },
      {
        text: "Geslacht",
        align: "left",
        value: "clientGender",
        sortable: true,
      },
      {
        text: "Laatst verzonden",
        align: "left",
        value: "lastDateSend.seconds",
        sortable: true,
      },
      {
        text: "Surveys",
        align: "center",
        value: "clientSurveysNumber",
        sortable: true,
      },
      {
        text: "Gemiddelde score",
        align: "left",
        value: "clientTotalScore",
        sortable: true,
      },
      {
        text: "Vragen beantwoord",
        align: "left",
        value: "clientQuestionsAnswered",
        sortable: true,
      },
      {
        text: "Laagste score",
        align: "left",
        value: "clientLowestScore",
        sortable: true,
      },
      {
        text: "Feedback",
        align: "center",
        value: "surveyfeedback",
        sortable: true,
      },
    ],
    pagination: {
      rowsPerPage: -1,
      sortBy: "clientName",
      descending: false,
    },
  }),

  created() {
    this.loadUserComp();
    this.today = moment().format("YYYY-MM-DD");
    bus.$on("surveyEditDialogChange", (survey) => {
      this.replaceSurveyData(survey);
    });
  },

  methods: {
    loadUserComp() {
      this.loadingUserData = true;
      this.loading = true;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0;

      new Promise((resolve, reject) => {
        if (this.userRole == "superadmin") {
          db.collection("companies")
            .get()
            .then((snap) => {
              this.companies = [];
              snap.forEach((doc) => {
                let company = doc.data();
                company.id = doc.id;
                this.companies.push(company);
              });
            })
            .then(() => {
              resolve();
            });
        } else {
          this.userCompanies.forEach((company) => {
            db.collection("companies")
              .doc(company)
              .get()
              .then((doc) => {
                let company = doc.data();
                company.id = doc.id;
                this.companies.push(company);
                counter++;
                if (counter == this.userCompanies.length) {
                  resolve();
                }
              });
          });
        }
      }).then(() => {
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if (this.userRole == "superadmin") {
          // Super Admins have access to multiple companies
          let selectedCompany = window.localStorage.getItem("selectedCompany");

          // Check if a selected company is set in the Local Storage
          if (selectedCompany) {
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, {
              id: selectedCompany,
            });

            // Selected company is an option, set activeComp
            if (selectedCompanyIndex >= 0) {
              this.filter.selectedCompany = this.companies[
                selectedCompanyIndex
              ].id;
              this.loadCompanyJourneys();
            }
            // Selected company is no option, set first company as activeComp
            else {
              window.localStorage.getItem(
                "selectedCompany",
                this.companies[0].id,
              );
              this.filter.selectedCompany = this.companies[0].id;
              this.loadCompanyJourneys();
            }
          }
          // No selected company is set
          else {
            this.filter.selectedCompany = this.companies[0].id;
            this.loadCompanyJourneys();
            window.localStorage.setItem(
              "selectedCompany",
              this.companies[0].id,
            );
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.filter.selectedCompany = this.companies[0].id;
          this.loadCompanyJourneys();
        }
      });
    },

    loadActiveCompData() {
      db.collection("companies")
        .doc(this.filter.selectedCompany)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },

    replaceSurveyData(survey) {
      let index = _.findIndex(this.surveys, ["id", survey.id]);

      if (index >= 0) {
        this.surveys[index] = survey;
        this.loadClients();
      }
    },

    // De journeys die horen bij de geselecteerde company binnenhalen
    loadCompanyJourneys() {
      console.log("Load company journeys");
      this.loadingUserData = true;
      window.localStorage.setItem(
        "selectedCompany",
        this.filter.selectedCompany,
      );
      this.loadActiveCompData();
      this.loading = true;
      this.journeys = [];
      db.collection("journeys")
        .where(`companies.${this.filter.selectedCompany}`, "==", true)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            let journeyCollection = doc.data();
            journeyCollection.id = doc.id;
            this.journeys.push(journeyCollection);
          });
        })

        .then(() => {
          if (this.journeys.length > 0) {
            // Journeys gevonden
            this.filter.selectedJourney = this.journeys[0].id;
            this.loadBranches();
          } else {
            // Geen journeys gevonden
            this.filter.selectedJourney = null;
            this.noData = true;
            this.loading = false;
          }
        })
        .catch(() => {
          console.error("Error bij laden journeys: ", error);
        });
    },

    // Load Branches van geselecteerd bedrijf
    loadBranches() {
      console.log("Laod Branches");
      this.branches = [];
      if (this.userRole == "superadmin" || this.userRole == "admin") {
        db.collection("branches")
          .where("compId", "==", this.filter.selectedCompany)
          .get()
          .then((snap) => {
            snap.forEach((doc) => {
              let branchCollection = doc.data();
              branchCollection.id = doc.id;
              this.branches.push(branchCollection);
            });
          })
          .then(() => {
            if (this.branches.length > 0) {
              let branchesArray = [];
              let counter = 0;
              new Promise((resolve, reject) => {
                this.branches.forEach((branch) => {
                  branchesArray.push(branch.id);
                  counter++;
                  if (counter == this.branches.length) {
                    resolve();
                  }
                });
              }).then(() => {
                this.filter.selectedBranches = branchesArray;
                this.checkMinimumDate();
              });
            } else {
              this.filter.selectedBranches = null;
              this.noData = true;
              this.loading = false;
            }
          });
      } else {
        if (this.userBranches.length > 0) {
          let counter = 0;
          new Promise((resolve, reject) => {
            this.userBranches.map((branch) => {
              db.collection("branches")
                .doc(branch)
                .get()
                .then((doc) => {
                  let branchCollection = doc.data();
                  branchCollection.id = doc.id;
                  this.branches.push(branchCollection);
                  counter++;
                  if (counter == this.userBranches.length) {
                    resolve();
                  }
                });
            });
          }).then(() => {
            if (this.branches.length > 0) {
              let branchesArray = [];
              let counter = 0;
              new Promise((resolve, reject) => {
                this.branches.forEach((branch) => {
                  branchesArray.push(branch.id);
                  counter++;
                  if (counter == this.branches.length) {
                    resolve();
                  }
                });
              }).then(() => {
                this.filter.selectedBranches = branchesArray;
                this.checkMinimumDate();
              });
            }
          });
        } else {
          this.filter.selectedBranches = null;
          this.noData = true;
          this.loading = false;
        }
      }
    },

    // Kijken wat de eerste datum was van een survey
    checkMinimumDate() {
      let minDates = [];
      let noData = false;
      let counter = 0;

      new Promise((resolve, reject) => {
        this.filteredBranches.forEach((branch) => {
          if (branch.firstSurveyDate) {
            let dateNumberSeconds = Number(branch.firstSurveyDate.seconds);
            minDates.push(dateNumberSeconds);
          }
          counter++;
          if (counter == this.filteredBranches.length) {
            resolve();
          }
        });
      })
        .then(() => {
          if (minDates.length > 0) {
            let minDate = Math.min.apply(null, minDates);
            this.minDate = moment.unix(minDate).format("YYYY-MM-DD");
            let sevenDaysAgo = moment()
              .subtract(7, "days")
              .format("X");

            if (minDate > sevenDaysAgo) {
              this.filter.startDate = moment.unix(minDate).format("YYYY-MM-DD");
            } else {
              this.filter.startDate = moment
                .unix(sevenDaysAgo)
                .format("YYYY-MM-DD");
            }
            this.filter.endDate = moment().format("YYYY-MM-DD");
          } else {
            noData = true;
          }
        })
        .then(() => {
          if (!noData) {
            this.loadingUserData = false;
            this.noData = false;
            if (this.filteredBranches.length == 1) {
              this.loadSurveys();
            } else {
              this.loading = false;
              this.noData = true;
            }
          } else {
            this.loadingUserData = false;
            this.noData = true;
            this.loading = false;
          }
        });
    },

    loadSurveys() {
      this.filterSaved = _.cloneDeep(this.filter);
      this.loading = true;
      this.surveys = [];
      let start = new Date(this.filter.startDate);
      let end = new Date(this.filter.endDate);

      let counter = 0;

      new Promise((resolve, reject) => {
        this.filteredBranches.map((branch) => {
          if (this.filter.answered) {
            db.collection("surveys")
              .where("journeyId", "==", this.filter.selectedJourney)
              .where("branchId", "==", branch.id)
              .where("dateSend", ">=", start)
              .where("dateSend", "<=", end)
              .where("answered", "==", true)
              .orderBy("dateSend")
              .get()
              .then((snap) => {
                snap.forEach((doc) => {
                  let survey = doc.data();
                  survey.id = doc.id;
                  survey.expanded = false;
                  this.surveys.push(survey);
                });
              })
              .then(() => {
                counter++;
                if (counter == this.filteredBranches.length) {
                  resolve();
                }
              })
              .catch((error) => {
                counter++;
                if (counter == this.filteredBranches.length) {
                  resolve();
                }
                console.error(
                  "Error bij binnenhalen van surveys van " +
                    branch.branchName +
                    ": ",
                  error,
                );
              });
          } else {
            db.collection("surveys")
              .where("journeyId", "==", this.filter.selectedJourney)
              .where("branchId", "==", branch.id)
              .where("dateSend", ">=", start)
              .where("dateSend", "<=", end)
              .orderBy("dateSend")
              .get()
              .then((snap) => {
                snap.forEach((doc) => {
                  let survey = doc.data();
                  survey.id = doc.id;
                  survey.expanded = false;
                  this.surveys.push(survey);
                });
              })
              .then(() => {
                counter++;
                if (counter == this.filteredBranches.length) {
                  resolve();
                }
              })
              .catch((error) => {
                counter++;
                if (counter == this.filteredBranches.length) {
                  resolve();
                }
                console.error(
                  "Error bij binnenhalen van surveys van " +
                    branch.branchName +
                    ": ",
                  error,
                );
              });
          }
        });
      })
        .then(() => {
          this.surveyClients = _.uniqBy(this.surveys, "clientId");
        })
        .then(() => {
          if (this.surveys.length > 0) {
            this.noData = false;
            this.loadClients();
          } else {
            this.noData = true;
            this.loading = false;
          }
        });
    },

    setMininumDateOne() {
      let minDateBranches = this.minDateBranchOne;

      if (minDateBranches.length > 0) {
        this.minDateOne = moment
          .unix(Math.min.apply(null, minDateBranches))
          .format("D MMM YYYY");
        this.startOne = moment.unix(Math.min.apply(null, minDateBranches));
        this.selectedStartDateOne = moment.unix(
          Math.min.apply(null, minDateBranches),
        );
      } else {
        this.selectedStartDateOne = moment();
        this.startOne = moment();
        this.minDateOne = moment()
          .subtract(1, "month")
          .add(1, "days");
      }
    },

    closeClientViewDialog() {
      this.viewClientDialog = false;
      this.viewClientInfo = {};
      this.clientSurveys = {};
    },

    closeCompDialog() {
      this.viewClientDialog = false;
    },

    viewClient(item) {
      this.clientDataLoaded = false;
      this.viewClientDialog = true;
      this.viewClientInfo = Object.assign({}, item);
      this.loadClientData();
    },

    // Ophalen van clienten en de bijgehorende surveys
    loadClients() {
      this.clients = [];
      let counter = 0;

      new Promise((resolve, reject) => {
        // console.log("Start new surveyClients")
        this.surveyClients.forEach((survey) => {
          db.collection("clients")
            .doc(survey.clientId)
            .get()
            .then((doc) => {
              let client = doc.data();
              client.id = doc.id;

              let clientSurveys = [];
              let clientSurveysScores = [];
              let clientQuestionsAnswered = null;

              client.clientQuestionsAnswered = 0;
              client.clientTotalScore = null;
              client.clientSurveysNumber = null;
              client.clientLowestScore = null;
              client.clientLowestScore = null;

              client.lastDateSend = doc.data().companies[
                survey.compId
              ].lastDateSend;

              // Surveys van de client zoeken

              let surveyCounter = 0;
              new Promise((resolve, reject) => {
                this.surveys.map((activeSurvey) => {
                  if (activeSurvey.clientId == doc.id) {
                    client.clientSurveysNumber++;
                    clientSurveys.push(activeSurvey);
                  }
                  surveyCounter++;
                  if (surveyCounter == this.surveys.length) {
                    resolve();
                  }
                });
              }).then(() => {
                let clientSurveyCounter = 0;
                new Promise((resolve, reject) => {
                  clientSurveys.map((clientSurvey) => {
                    if (clientSurvey.answered) {
                      clientSurvey.surveyQuestions.map((question) => {
                        if (question.rating) {
                          clientSurveysScores.push(question.rating);
                          client.clientQuestionsAnswered++;
                        } else if (question.feedback) {
                          client.clientFeedback = true;
                          client.clientQuestionsAnswered++;
                        }
                      });
                    }
                    clientSurveyCounter++;
                    if (clientSurveyCounter == clientSurveys.length) {
                      resolve();
                    }
                  });
                }).then(() => {
                  client.clientTotalScore =
                    _.sum(clientSurveysScores) / clientSurveysScores.length;
                  client.clientSurveysNumber = clientSurveys.length;
                  client.clientLowestScore = _.min(clientSurveysScores);
                  this.clients.push(client);
                });
              });
            })
            .then(() => {
              counter++;
              if (counter == this.surveyClients.length) {
                resolve();
              }
            })
            .catch((error) => {
              counter++;
              if (counter == this.surveyClients.length) {
                resolve();
              }
              console.error(
                "Error bij binnenhalen van clientData van " +
                  survey.clientName +
                  ": ",
                error,
              );
            });
        });
      }).then(() => {
        this.loading = false;
      });
    },

    loadClientData() {
      this.clientSurveys = [];
      let counter = 0;
      new Promise((resolve, reject) => {
        this.surveys.map((survey) => {
          if (survey.clientId == this.viewClientInfo.id) {
            this.clientSurveys.push(survey);
          }
          counter++;
          if (counter == this.surveys.length) {
            resolve();
          }
        });
      }).then(() => {
        this.clientDataLoaded = true;
      });
    },

    // Datum omvormen naar Europese leesbare datum
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
  },

  computed: {
    reviewsPackage() {
      let packageStatus = {
        type: "inactive",
        days: 0,
      };

      if (
        this.activeCompData.packages &&
        this.activeCompData.packages.length > 0 &&
        _.indexOf(this.activeCompData.packages, "customerjourney") >= 0
      ) {
        packageStatus.type = "active";
      } else {
        // Package not purchased, check for active trial
        if (
          this.activeCompData.trials &&
          this.activeCompData.trials.length > 0
        ) {
          this.activeCompData.trials.forEach((trailPackage) => {
            if (trailPackage.id == "customerjourney") {
              // Trial found, check if trialperiod is still active
              if (
                moment(trailPackage.trialStartDate).add(
                  trailPackage.trialDays,
                  "days",
                ) > moment()
              ) {
                packageStatus.type = "trial";
                packageStatus.days = moment(trailPackage.trialStartDate)
                  .add(trailPackage.trialDays, "days")
                  .diff(moment(), "days");
              }
            }
          });
        }
      }
      return packageStatus;
    },

    filteredBranches() {
      let branches = [];
      this.branches.forEach((branch) => {
        this.filter.selectedBranches.forEach((selectedBranch) => {
          if (selectedBranch == branch.id) {
            branches.push(branch);
          }
        });
      });
      return branches;
    },

    // Datum omvormen naar Europese leesbare datum
    filterStartDateFormatted() {
      return this.formatDate(this.filter.startDate);
    },

    filterEndDateFormatted() {
      return this.formatDate(this.filter.endDate);
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userBranches() {
      return this.$store.state.userBranches;
    },
    userId() {
      return this.$store.state.userId;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    demoMode() {
      return this.$store.state.demoMode;
    },

    filterChanged() {
      if (_.isEqual(this.filter, this.filterSaved) == false) {
        return false;
      } else {
        return true;
      }
    },
    filteredCompanies() {
      if (this.searchCompanies && this.searchCompanies.length > 0) {
        return this.companies.filter((company) => {
          return company.name
            .toLowerCase()
            .includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies;
      }
    },
  },
};
</script>
